<!-- @format -->

<ng-container *transloco="let t">
  <app-widget-container [title]="t('FRONTPAGE.RECENT_ATTAINMENTS.TITLE')" [subtitle]="t('FRONTPAGE.RECENT_ATTAINMENTS.SUBTITLE')">
    @if (recentAttainments$ | async; as attainments) {
      @if (attainments?.length) {
        <ul>
          @for (attainment of attainments; track attainment) {
            <li>
              <app-attainment-info [attainment]="attainment" (clicked)="onAttainmentClick($event)" />
              <hr aria-hidden="true" />
            </li>
          }
        </ul>
      }
      @if (!attainments?.length && !searchFailed()) {
        <p class="app-widget-container__content__info-text sis-mb-zero">
          {{ t("FRONTPAGE.RECENT_ATTAINMENTS.NO_ITEMS") }}
        </p>
      }
    } @else {
      <div aria-busy="true" class="d-flex justify-content-center">
        <sis-small-spinner />
      </div>
    }

    @if (searchFailed()) {
      <p class="app-widget-container__content__info-text sis-mb-zero">
        {{ t("FRONTPAGE.RECENT_ATTAINMENTS.FETCHING_ATTAINMENTS_FAILED") }}
      </p>
    }
    <a
      fudisLink
      [href]="profileAttainmentsHref"
      [external]="true"
      class="fudis-mt-xxs"
      [title]="t('FRONTPAGE.RECENT_ATTAINMENTS.SHOW_ALL_ATTAINMENTS')"></a>
  </app-widget-container>
</ng-container>
